import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button as ButtonMui, ButtonProps } from '@mui/material';

import { ReactComponent as BackIcon } from 'assets/icons/BackIcon.svg';

import { backButtonStyle } from './BackButton.style';

interface IProps extends ButtonProps {}

export const BackButton: FC<IProps> = ({ ...props }) => {
  const { t } = useTranslation();
  return (
    <ButtonMui sx={backButtonStyle} {...props}>
      <BackIcon />
      {t('back')}
    </ButtonMui>
  );
};
